import React from "react";
import { AnimatePresence } from "framer-motion";
import { useToastStore } from "@stores/notifications/toastStore";
import { Toast } from "./Toast";

export const ToastContainer: React.FC = () => {
    const notifications = useToastStore((s) => s.notifications);
    const removeNotification = useToastStore((s) => s.removeNotification);

    return (
        <div className="fixed bottom-4 end-4 z-[99999] flex flex-col gap-2 pointer-events-none">
            <AnimatePresence mode="popLayout">
                {notifications.map((notification, index) => (
                    <div
                        key={`${notification.id}-${index}`}
                        className="pointer-events-auto"
                    >
                        <Toast
                            notification={notification}
                            onClose={() => removeNotification(notification.id)}
                        />
                    </div>
                ))}
            </AnimatePresence>
        </div>
    );
};
